import { useTranslation } from "react-i18next";
import { GenericButton } from "shared/ui-basics";
import styled from "styled-components/macro";

const CreateNewItem = ({ create, renderItem, createLabel }) => {
	const { t } = useTranslation();

	return (
		<MenuItemContainer>
			<NewItemCreation>
				<GenericButton variant="dark-outline" size="xs" onClick={create}>
					{t(createLabel)}
				</GenericButton>
				{renderItem()}
			</NewItemCreation>
		</MenuItemContainer>
	);
};

CreateNewItem.displayName = "CreateNewItem";
export default CreateNewItem;

const MenuItemContainer = styled.div`
	height: 32px;
	width: 100%;
	padding: 4px;
	display: flex;
    align-items: center;
	:hover {
		border-radius: 4px;
		background: #f5f5f5;
	}
`;

const NewItemCreation = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
`;
